import React, { Component } from 'react'
import Select from 'react-select'

class Vaccination extends Component {
    constructor() {
        super()
        this.state = {
            VaccinationList:[ {"label":"Not Done","value":"Not Done"},{"label":"Partially","value":"Partially"},{"label":"Fully","value":"Fully"}]
        }
        this.isComponentStillMounted = true
    }

   

    componentWillUnmount() {
        this.isComponentStillMounted = false
    }

    

    render() {
       return (
            <div>
                <Select
                value={this.props.selectedValue}
                options={this.state.VaccinationList}
                placeholder="Select Vaccination"
                onChange={(e) => { (e) ? this.props.vaccinationChange(e) : this.props.ragChange([])}}
                />
            </div>
        )
    }
}

export default Vaccination


// WEBPACK FOOTER //
// ./src/modules/Employees/Components/DropDowns/Vaccination.js